import * as React from "react";
import { forwardRef, memo } from "react";
const SvgBw = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 36 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#6DA9D2", d: "M0 0h36v24H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 9h36v6H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 10h36v4H0z" }));
const ForwardRef = forwardRef(SvgBw);
const Memo = memo(ForwardRef);
export default Memo;
